export default __webpack_public_path__ + "images/GOVERNORS.31aa166.png";